export const SPARK_CONFIG = {
  ANIMATION_DURATION: 5500,
  MIN_INITIAL_DELAY: 0,
  MAX_INITIAL_DELAY: 3000,
  MIN_BETWEEN_DELAY: 0,
  MAX_BETWEEN_DELAY: 3000,
  AFTER_ANIMATION_PAUSE: 0,
  MAX_AGE_HOURS: 72,
  SIZE_MULTIPLIER: 25,
  POSITION_RANGE: 0.20,
  BLUR_SIZE: 2
} as const;

export const isHexagonNew = (epochSec: number): boolean => {
  const currentTime = Date.now() / 1000;
  const hexAge = currentTime - epochSec;
  return hexAge < SPARK_CONFIG.MAX_AGE_HOURS * 60 * 60;
};